<style>
.box-all {
  background: white;
  min-height: 100%;
  height: auto !important;
}
.mt {
  padding-top: 80px;
}
@media screen and (max-width: 768px) {
  .container {
    padding: 0 5px;
  }
}
</style>
<template>
  <div
    :class="{'box-all container':router!='asset_index'&&router!='asset_invoiceTip'&&router!='asset_textTip'&&router!='asset_download'&&router!='default.dyIndex'&&router!='default.noticePage'&&router!='default.dynotice'}"
  >
    <router-view :key="router"></router-view>
    <div class="clear"></div>
    <div :class="{'mt':router!='default.dyIndex'&&router!='default.noticePage'&&router!='default.dynotice'}"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    getData: function() {
      if (this.currentExamInfo) {
        document.getElementsByTagName("body")[0].className = "";
        document
          .getElementsByTagName("body")[0]
          .classList.add(this.currentExamInfo.color_theme + "-theme");
      }
    }
  },
  created: function() {
    this.getData();
  },
  computed: {
    currentExamInfo: function() {
      return this.$store.state.examInfo.currentExamInfo;
    },
    router: function() {
      return this.$route.name;
    }
  },
  watch: {
    currentExamInfo(val) {
      this.getData();
    }
  }
};
</script>